import { useLocation } from 'react-router-dom';

export const useGetLocationPath = () => {
  const location = useLocation();
  return location.pathname;
};
